import React from 'react';
export function Reviews() {
  const reviews = [{
    text: 'Probé con videos sueltos de YouTube durante meses y no avanzaba. Con el método en orden, en tres semanas ya toqué mi primera canción completa.',
    author: 'Martín D. · Rosario'
  }, {
    text: 'Le compré esto a mi hijo de 12 años y terminé aprendiendo yo también. Los ejercicios están explicados como para alguien que arranca de cero de verdad.',
    author: 'Vanina L. · Mendoza'
  }, {
    text: 'Siempre quise tocar en los asados de la familia. A las cuatro semanas toqué mi primera canción entera y por primera vez no me dio vergüenza sacar la guitarra.',
    author: 'Federico A. · Buenos Aires'
  }];
  return <section className="w-full bg-white text-fondo-principal py-section px-4" data-id="element-164">
      <h2 className="text-2xl font-bold text-center mb-8" data-id="element-165">
        Lo que dicen quienes ya empezaron
      </h2>
      <div className="flex flex-col gap-4" data-id="element-166">
        {reviews.map((review, idx) => <div key={idx} className="bg-gray-50 p-6 rounded-2xl border border-gray-100 shadow-sm" data-id="element-167">
            <div className="text-badges-dorado mb-3 text-lg" data-id="element-168">🌟🌟🌟🌟🌟</div>
            <p className="italic text-gray-700 mb-4" data-id="element-169">"{review.text}"</p>
            <p className="font-semibold text-sm" data-id="element-170">— {review.author}</p>
          </div>)}
      </div>
    </section>;
}